import React from 'react';
import { Button } from '@components';
import { Card, Form, Row, Col, ButtonGroup } from 'react-bootstrap';
import { Formik } from 'formik';
import * as yup from 'yup';
import { useHistory } from 'react-router-dom';
import { toast } from 'react-toastify';
import { TINH_API, XA_API } from '@app/utils/apiUrl.js';
import { useMutation, useQuery } from 'react-query';
import { Get, Post } from '@app/utils/httpProvider';
import { messageToast, status200, status201 } from '@app/utils/define';

const schema = yup.object().shape({
    tinhId: yup.string().required('Vui lòng chọn tỉnh / thành phố'),
    tenXa: yup.string().trim().required('Tên xã / phường không được để trống')
});

const XaAdd = () => {
    const history = useHistory();

    const tinhList = useQuery(['tinhAllOptions'], () => Get(TINH_API.GET_ALL));
    const addFunc = useMutation((value) => Post(XA_API.ADD_ITEM, null, value, false));

    const handleCreate = async (values) => {
        const payload = {
            tinhId: values.tinhId,
            tenXa: values.tenXa.trim()
        };

        addFunc.mutate(payload, {
            onSuccess: (res) => {
                if (res && (res.status === status200 || res.status === status201)) {
                    toast.success(messageToast.messageToastCreateSuccess);
                    history.goBack();
                } else {
                    toast.error(messageToast.messageToastCreateError);
                }
            },
            onError: (err) => {
                toast.error(err?.message || 'Đã có lỗi xảy ra, vui lòng thử lại!');
            }
        });
    };

    return (
        <Card>
            <Card.Header as="h5">Thêm xã / phường</Card.Header>
            <Card.Body>
                <Formik
                    validationSchema={schema}
                    onSubmit={(values) => handleCreate(values)}
                    initialValues={{
                        tinhId: '',
                        tenXa: ''
                    }}
                >
                    {({ handleSubmit, handleChange, values, errors }) => (
                        <Form noValidate onSubmit={handleSubmit}>
                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Tỉnh / Thành phố <span className="text-danger">*</span>
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        as="select"
                                        name="tinhId"
                                        value={values.tinhId}
                                        onChange={handleChange}
                                        isInvalid={!!errors.tinhId}
                                    >
                                        <option value="">-- Chọn tỉnh / thành phố --</option>
                                        {tinhList.data &&
                                            Array.isArray(tinhList.data) &&
                                            tinhList.data.map((t) => (
                                                <option key={t.id || t.Id} value={t.id || t.Id}>
                                                    {t.tenTinh || t.TenTinh}
                                                </option>
                                            ))}
                                    </Form.Control>
                                    <Form.Control.Feedback type="invalid">
                                        {errors.tinhId}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Form.Label className="col-sm-2 col-form-label">
                                    Tên xã / phường <span className="text-danger">*</span>
                                </Form.Label>
                                <Col sm="10">
                                    <Form.Control
                                        placeholder="Nhập tên xã / phường"
                                        type="text"
                                        name="tenXa"
                                        value={values.tenXa}
                                        onChange={handleChange}
                                        isInvalid={!!errors.tenXa}
                                    />
                                    <Form.Control.Feedback type="invalid">
                                        {errors.tenXa}
                                    </Form.Control.Feedback>
                                </Col>
                            </Form.Group>

                            <Form.Group as={Row} className="mb-3">
                                <Col md={{ span: 10, offset: 2 }}>
                                    <ButtonGroup>
                                        <Button type="submit" theme="primary" disabled={addFunc.isLoading}>
                                            Thêm
                                        </Button>
                                        <Button
                                            type="button"
                                            theme="secondary"
                                            onClick={() => history.goBack()}
                                        >
                                            Hủy
                                        </Button>
                                    </ButtonGroup>
                                </Col>
                            </Form.Group>
                        </Form>
                    )}
                </Formik>
            </Card.Body>
        </Card>
    );
};

export default XaAdd;
